import { AuthService } from './auth.service';
import { Injectable, Injector } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class HttpCustomInterceptor implements HttpInterceptor {

  // TODO: monitor for workaround
  // do not build AuthService in the constructor to avoid getting a circular dependency issue
  // as AuthService calls interceptor as well
  // temp workaround is to build auth in the function using Injectors
  constructor(private injector: Injector) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    request = request.clone({
      setHeaders: {
        Authorization: `${this.getIdToken()}`
      }
    });

    return next.handle(request);
  }

  // we cannot get IdToken directly from LocalStorage
  // we have to do it through AWS-SDK, which is wrapped by AuthService
  getIdToken() {
    const auth = this.injector.get(AuthService);
    const sessionInfo = auth.sessionSubject.value;
    return sessionInfo.getIdToken().getJwtToken();
  }

}



// WEBPACK FOOTER //
// /Users/sensorflow/Documents/legacy/kalinda/Dashboard/sensorflow-dashboard/src/app/core/http-custom-interceptor.ts